import { NotifyHelper } from "../../../helpers/toast";
import { eLopBanActionsObj } from "../../action-types/category/ILopBanActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const lopBanActions = {
    ...generateActions(eLopBanActionsObj, "LOP_BAN"),
    ...generateActionForKey(eLopBanActionsObj, "LOP_BAN", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eLopBanActionsObj, "LOP_BAN", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eLopBanActionsObj, "LOP_BAN", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eLopBanActionsObj, "LOP_BAN", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
